var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4875_6832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6664 6.0447C14.518 6.15377 14.4569 6.34573 14.5137 6.52029L15.1987 8.6321C15.3274 9.02482 14.8802 9.3477 14.5464 9.1077L12.7487 7.80091C12.6004 7.69404 12.3996 7.69404 12.2513 7.80091L10.4536 9.1077C10.1198 9.34765 9.67259 9.02477 9.80131 8.6321L10.4863 6.52029C10.5431 6.34573 10.482 6.15377 10.3336 6.0447L8.53597 4.74007C8.20217 4.49791 8.37453 3.97216 8.78464 3.97216H11.0078C11.1911 3.97216 11.3525 3.85437 11.4092 3.6798L12.0964 1.56584C12.223 1.17532 12.777 1.17532 12.9036 1.56584L13.5908 3.6798C13.6475 3.85437 13.809 3.97216 13.9922 3.97216H16.2153C16.6255 3.97216 16.7978 4.49791 16.464 4.74007L14.6664 6.0447Z",
    fill: "url(#paint0_linear_4875_6832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11505 9.2803C6.99425 9.36912 6.94442 9.52545 6.99069 9.66762L7.54859 11.3875C7.65345 11.7073 7.28919 11.9703 7.01736 11.7748L5.55331 10.7105C5.43252 10.6235 5.26902 10.6235 5.14822 10.7105L3.68417 11.7748C3.41234 11.9703 3.04808 11.7073 3.15294 11.3875L3.71084 9.66762C3.75706 9.52545 3.70733 9.36912 3.58648 9.2803L2.12244 8.21778C1.85061 8.02058 1.99095 7.59238 2.32498 7.59238H4.13553C4.28478 7.59238 4.41622 7.49642 4.46248 7.35425L5.02217 5.63258C5.12525 5.31453 5.57652 5.31453 5.67955 5.63258L6.23923 7.35425C6.28541 7.49642 6.41689 7.59238 6.56614 7.59238H8.37664C8.71072 7.59238 8.85106 8.02058 8.57923 8.21778L7.11505 9.2803Z",
    fill: "url(#paint1_linear_4875_6832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4137 9.2803C21.2929 9.36912 21.243 9.52545 21.2893 9.66762L21.8472 11.3875C21.9521 11.7073 21.5878 11.9703 21.316 11.7748L19.8519 10.7105C19.7311 10.6235 19.5676 10.6235 19.4468 10.7105L17.9828 11.7748C17.711 11.9703 17.3467 11.7073 17.4515 11.3875L18.0095 9.66762C18.0557 9.52545 18.0059 9.36912 17.8851 9.2803L16.421 8.21778C16.1492 8.02058 16.2896 7.59238 16.6236 7.59238H18.4341C18.5834 7.59238 18.7148 7.49642 18.7611 7.35425L19.3208 5.63258C19.4239 5.31453 19.8751 5.31453 19.9782 5.63258L20.5378 7.35425C20.584 7.49642 20.7155 7.59238 20.8647 7.59238H22.6752C23.0093 7.59238 23.1497 8.02058 22.8778 8.21778L21.4137 9.2803Z",
    fill: "url(#paint2_linear_4875_6832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80597 13.3789V21.0712H2.19936V14.0986C2.19936 13.7001 2.52059 13.3789 2.91903 13.3789H8.80597Z",
    fill: "url(#paint3_linear_4875_6832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8011 14.0986V21.0712H16.1945V13.3789H22.0814C22.4798 13.3789 22.8011 13.7002 22.8011 14.0986Z",
    fill: "url(#paint4_linear_4875_6832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1945 11.4365V21.0712H8.80597V11.4365C8.80597 11.038 9.12973 10.7168 9.52564 10.7168H15.4748C15.8708 10.7168 16.1945 11.0381 16.1945 11.4365Z",
    fill: "url(#paint5_linear_4875_6832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2041 22.3995C24.2041 23.1381 23.6142 23.7267 22.8769 23.7267H2.12309C1.38734 23.7267 0.795875 23.1352 0.795875 22.3995C0.795875 21.6735 1.38012 21.0723 2.12309 21.0723H22.8769C23.6126 21.0723 24.2041 21.6676 24.2041 22.3995Z",
    fill: "url(#paint6_linear_4875_6832)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4875_6832",
    x1: 12.5,
    y1: 9.19001,
    x2: 12.5,
    y2: 1.27291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECBD0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4875_6832",
    x1: 5.35072,
    y1: 11.842,
    x2: 5.35072,
    y2: 5.39408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECBD0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4875_6832",
    x1: 19.6493,
    y1: 11.842,
    x2: 19.6493,
    y2: 5.39408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECBD0B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4875_6832",
    x1: 5.50269,
    y1: 21.0713,
    x2: 5.50269,
    y2: 13.3789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0969DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F8AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4875_6832",
    x1: 19.4978,
    y1: 21.0713,
    x2: 19.4978,
    y2: 13.3789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0969DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F8AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4875_6832",
    x1: 12.5002,
    y1: 21.0713,
    x2: 12.5002,
    y2: 10.7168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0168,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4875_6832",
    x1: 12.5,
    y1: 23.7267,
    x2: 12.5,
    y2: 21.0723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECBD0B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4875_6832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.49fac87143b2af63382b37cfdae97c2e.svg";
export { ForwardRef as ReactComponent };